import { OfferLetterStatusSlug } from 'modules/offerLetter/store/model';

export const isPayRateApprovalStatus = (offerStatusSlug: OfferLetterStatusSlug) => {
    return [
        OfferLetterStatusSlug.PendingPayRateApproval,
        OfferLetterStatusSlug.RejectedPayRate,
    ].includes(offerStatusSlug);
};
